import '../src/styles/globals.css';
import '@ungap/with-resolvers';
import '../src/polyfills/url-parse';

import { ApolloProvider } from '@apollo/client';
import { CacheProvider, EmotionCache } from '@emotion/react';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { AppProps } from 'next/app';

import { useApollo } from '@/graphql/client';
import { createEmotionCache } from '@/utils/createEmotionCache';

// Client-side Emotion cache, shared across the app
const clientSideEmotionCache = createEmotionCache();

interface CustomAppProps extends AppProps {
  emotionCache?: EmotionCache;
}

export default function CustomApp({
  Component,
  pageProps,
  emotionCache = clientSideEmotionCache,
}: CustomAppProps) {
  const apolloClient = useApollo(pageProps);

  if (!apolloClient) {
    return null;
  }

  return (
    <CacheProvider value={emotionCache}>
      {/* Put providers here that should be global to both authenticated and unauthenticated scenarios across the app */}
      {/* For auth-only/app scenarios, put providers in index.tsx */}
      {/* For login-only scenarios, put providers in login.tsx */}
      <ApolloProvider client={apolloClient}>
        <LocalizationProvider dateAdapter={AdapterDateFns}>
          <Component {...pageProps} />
        </LocalizationProvider>
      </ApolloProvider>
    </CacheProvider>
  );
}
